import React, { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Sparkles, Zap } from "lucide-react";
import { submitLead } from "../lib/api";
import { toast } from "sonner";

export default function HeroLeadCard() {
  const [form, setForm] = useState({ name: "", phone: "", city: "", monthly_bill: "", source: "hero" });
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.name || !form.phone) return toast.error("Please enter name and phone");
    setLoading(true);
    try {
      await submitLead({ ...form, monthly_bill: Number(form.monthly_bill) || undefined });
      toast.success("Thanks! Our expert will call within 24 hours.");
      setForm({ name: "", phone: "", city: "", monthly_bill: "", source: "hero" });
    } catch {
      toast.error("Submission failed. Try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-slate-200" data-testid="hero-lead-card">
      <div className="bg-slate-900 p-5 text-white border-b-4 border-yellow-400">
        <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest bg-yellow-400 text-slate-900 px-2.5 py-1 rounded-full mb-3">
          <Sparkles className="w-3.5 h-3.5" /> Free Consultation
        </div>
        <h3 className="font-heading text-2xl font-semibold text-white">Get your custom solar quote</h3>
        <p className="text-sm text-slate-300 mt-1">Our expert will call you back within 24 hours.</p>
      </div>
      <form onSubmit={handleSubmit} className="p-6 space-y-3" data-testid="hero-lead-form">
        <Input placeholder="Full Name *" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="hero-input-name" />
        <Input placeholder="Phone Number *" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="hero-input-phone" />
        <div className="grid grid-cols-2 gap-3">
          <Input placeholder="City" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} data-testid="hero-input-city" />
          <Select value={form.monthly_bill} onValueChange={(v) => setForm({ ...form, monthly_bill: v })}>
            <SelectTrigger data-testid="hero-input-bill"><SelectValue placeholder="Monthly bill" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="1500">Under ₹2,000</SelectItem>
              <SelectItem value="3500">₹2,000 – ₹5,000</SelectItem>
              <SelectItem value="7500">₹5,000 – ₹10,000</SelectItem>
              <SelectItem value="15000">₹10,000 – ₹20,000</SelectItem>
              <SelectItem value="30000">Above ₹20,000</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <Button type="submit" disabled={loading} className="w-full bg-yellow-400 hover:bg-yellow-500 text-slate-900 text-base py-6 font-semibold" data-testid="hero-submit-btn">
          <Zap className="w-4 h-4 mr-2" /> {loading ? "Sending..." : "Get Free Quote"}
        </Button>
        <p className="text-xs text-center text-slate-500">🔒 No spam. No hidden charges.</p>
      </form>
    </div>
  );
}
